// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__HnJXk","errorLogs":"styles_errorLogs__3ZhpT"};